<template>
  <div class="price-comparison-wrapper hp-block-container mx-4">
    <div class="price-comparison-container">
      <div class="left">
        <h3 class="hp-block-title">
          How much does our<br />
          cycling insurance cost?
        </h3>

        <div class="text">
          <p>
            Our smart cycling insurance provides cover for outstanding value, at
            a fixed amount each month so you’ll always know how much you’re
            paying. Maximum budget certainty at a fair price.
          </p>
          <p>
            We’ve been dedicated to cycling insurance since 2014. That’s all we
            do and we know what it takes to offer the most comprehensive cover
            for the most competitive price.
          </p>
        </div>

        <ul class="price-points">
          <li v-for="point in points" :key="point">
            <span class="tick" aria-hidden="true">
              <svg fill="none" viewBox="0 0 20 20" stroke="currentColor">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2.5"
                  d="M4 10.5l4 4 8-8"
                />
              </svg>
            </span>
            {{ point }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      points: [
        'Cover for theft, accidental and malicious damage',
        'Your price is fixed for the whole policy year',
        'We’ll match any cheaper quote for the same cover',
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.price-comparison-wrapper {
  border-bottom: 1px solid $ps-border;
}

.price-comparison-container {
  display: flex;
  flex-direction: column;
  gap: 32px;
  max-width: 1100px;
  margin: 0 auto;

  @include desktop {
    flex-direction: row;
    align-items: center;
    gap: 56px;
  }

  .left {
    flex: 1 1 0;
    min-width: 0;
  }
}

// The heading sits in the left column now, so it reads with the copy beneath
// it rather than centred above both columns.
.left {
  text-align: left;

  .hp-block-title {
    text-align: left;
    margin-bottom: 24px;
  }

  .text p {
    font-size: $ps-text-body;
    line-height: 1.7;
    color: $ps-body-color;

    + p {
      margin-top: 1.1em;
    }
  }
}

.price-points {
  list-style: none;
  margin: 28px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;

  li {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    font-size: $ps-text-body;
    line-height: 1.45;
    color: $ps-ink;
  }

  .tick {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    width: 24px;
    height: 24px;
    margin-top: 1px;
    border-radius: 50%;
    background: $ps-primary-50;
    color: $ps-primary;

    svg {
      width: 15px;
      height: 15px;
    }
  }
}
</style>
